import httpClient from "@/api/httpClient";
import CreateUserRequest from "@/model/CreateUserRequest";
import UserProfileResponse from "@/model/UserProfileResponse";
import ChangePasswordRequest from "@/model/ChangePasswordRequest";
import UserPage from "@/model/UserPage";

function listUsers(
  accessToken: string,
  page: number,
  size: number,
  search?: string
): Promise<UserPage> {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : "";
  return httpClient.getJson<UserPage>(
    `/api/users?page=${page}&size=${size}${searchParam}`,
    accessToken
  );
}

function createUser(
  accessToken: string,
  request: CreateUserRequest
): Promise<UserProfileResponse> {
  return httpClient.postJson<UserProfileResponse>(
    "/api/users",
    request,
    accessToken
  );
}

function getCurrentUser(accessToken: string): Promise<UserProfileResponse> {
  return httpClient.getJson<UserProfileResponse>("/api/users/me", accessToken);
}

function changePassword(
  accessToken: string,
  request: ChangePasswordRequest
): Promise<void> {
  return httpClient.putNoContent(
    "/api/users/me/password",
    request,
    accessToken
  );
}

const usersApi = {
  listUsers,
  createUser,
  getCurrentUser,
  changePassword,
};

export default usersApi;
